import type { FC } from 'react';

import type { DashboardVariableType } from 'src/types/dashboard';
import {
  AccordionItem,
  AccordionItemHeader,
  AccordionItemPanel,
} from 'src/components/common/Accordion';

import VariableAccordionItem from '../VariableAccordionItem';

export interface VariableTypeAccordionItemProps {
  variableType: DashboardVariableType;
}

const VariableTypeAccordionItem: FC<VariableTypeAccordionItemProps> = ({
  variableType,
}) => (
  <AccordionItem
    key={variableType.id}
    itemName={`dashboard-variable-type-${variableType.id}`}
  >
    <AccordionItemHeader
      headline={variableType.name}
      showSelectedFilterCountForKey={variableType.variables.map(
        (variable) => variable.variable_id,
      )}
    />

    <AccordionItemPanel>
      {variableType.variables.map((variable, i) => (
        <VariableAccordionItem
          key={`${variable.variable_id}-${i}`}
          variable={variable}
          nested
        />
      ))}
    </AccordionItemPanel>
  </AccordionItem>
);

export default VariableTypeAccordionItem;
